export default __webpack_public_path__ + "static/media/logo_short.1f6bedf0.svg";